<div class="discharge-report-validation-summary">
  @if (issues.length) {
    <div class="discharge-report-validation-card discharge-report-validation-card-error">
      <div class="discharge-report-validation-card-title">
        <i nz-icon nzType="warning" nzTheme="outline"></i>
        <span>
          {{ issues.length }}
          {{
            (issues.length === 1 ? 'Issue on this report' : 'Issues on this report')
              | translate
          }}
        </span>
      </div>
      <ul class="discharge-report-validation-list">
        @for (issue of issues; track issue.code + issue.path) {
          <li>{{ issue.message }}</li>
        }
      </ul>
    </div>
  }

  @if (warnings.length) {
    <div class="discharge-report-validation-card discharge-report-validation-card-warning">
      <div class="discharge-report-validation-card-title">
        <i nz-icon nzType="warning" nzTheme="outline"></i>
        <span>
          {{ warnings.length }}
          {{
            (warnings.length === 1 ? 'Warning on this report' : 'Warnings on this report')
              | translate
          }}
        </span>
      </div>
      <ul class="discharge-report-validation-list">
        @for (warning of warnings; track warning.code + warning.path) {
          <li>{{ warning.message }}</li>
        }
      </ul>
    </div>
  }
</div>